import React from 'react';
import './styles/DesignerStyles.css';
import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';
import imageCompression from 'browser-image-compression'

import DesignerButton from './DesignerButton';
import DesignerTextField from './DesignerTextField';

import { checkForCode, androidBackButton } from './Utils';

import penClick from './Sounds/pen-click.wav';

class Profile extends React.Component {
  static propTypes = {
    cookies: instanceOf(Cookies).isRequired,
  };

  constructor(props) {
    super(props);

    // eslint-disable-next-line
    const { cookies } = props;
    this.penClick = new Audio(penClick);

    this.state = {
      userEmail: 'email@google.com',
      userNickname: '',
      profilePicture: 'url(../Images/Profile-Base-NoPicture.svg)',
      appState: 'BASKET',
      appMessage: '',
      userStatus: 'Basic',
    };
  }

  componentDidMount() {
    androidBackButton(this.handleGoBackRoom);

    checkForCode(
      'GET',
      `/api/users/${this.props.cookies.get('code')}`,
      this.props,
      null
    ).then((data) => {
      this.setState({
        userEmail: data.email,
        userNickname: data.nickname,
        profilePicture: data.profilePicture,
        userStatus: data.type,
      });
    });
  }

  handlePurchase = () => {
    //purchasePremiumStatus();
    //console.log('purchasePremiumStatus() is commented out');

    // Replace with actual product ID
    const productId = 'premium';

    // Check if the plugin is available
    if (window.inAppPurchases) {
      // Start the purchase process
      window.inAppPurchases
        .getAllProductInfo([productId])
        .then(products => {
          console.log(`products are ${JSON.stringify(products)}`);
          return window.inAppPurchases.purchase(productId);
        })
        .then((data) => {
          console.log('Purchase success:', data);
          return checkForCode(
            'PUT',
            `/api/users/${this.props.cookies.get('code')}/setPremiumUserStatus`,
            this.props,
            null
          );
        }).then(() => {
          return window.inAppPurchases.completePurchase(productId, false);
        }).then((purchase) => {
          console.log("purchase success!");
          console.log(purchase);
          this.setState({userStatus: "Premium"});
        }).catch((err) => {
          console.error('Purchase failed:', JSON.stringify(err));
        });
    } else {
      console.error('In-App Purchases plugin not available');
    }
  };

  handleUploadClick = async (event) => {
    var file = event.target.files[0];
    console.log('originalFile instanceof Blob', file instanceof Blob); // true
    console.log(`originalFile size ${file.size / 1024 / 1024} MB`);

    try {
      const compressedFile = await imageCompression(file, {
        maxSizeMB: 1,
        maxWidthOrHeight: 196,
        useWebWorker: true,
      });
      console.log('compressedFile instanceof Blob', compressedFile instanceof Blob); // true
      console.log(`compressedFile size ${compressedFile.size / 1024 / 1024} MB`); // smaller than maxSizeMB

      this.setState({ profilePicture: compressedFile})

      const reader = new FileReader();
      if (compressedFile) {
        // eslint-disable-next-line
        var url = reader.readAsDataURL(compressedFile);
      }

      reader.onloadend = async function (e) {
        this.setState({ profilePicture: reader.result });
      }.bind(this);
    } catch (error) {
      console.log(error);
    }

    // const reader = new FileReader();
    // if (file) {
    //   // eslint-disable-next-line
    //   var url = reader.readAsDataURL(file);
    // }

    // reader.onloadend = async function (e) {
    //   this.setState({ profilePicture: reader.result });
    // }.bind(this);
  };

  SaveChanges = () => {
    let body = JSON.stringify({
      nickname: this.state.userNickname,
      profilePicture: this.state.profilePicture,
    });

    checkForCode(
      'PUT',
      `/api/users/${this.props.cookies.get('code')}`,
      this.props,
      body
    ).then((data) => {
      console.log('data in save changes: ' + JSON.stringify(data));
    });
  };

  handleGoBackRoom = () => {
    this.penClick.play();
    this.props.navigate(`/`);
  };

  deleteAccount = () => {
    checkForCode('DELETE', `/api/users/${this.props.cookies.get('code')}`, this.props).
      then((data) => {
        this.props.cookies.remove('code');
        this.props.navigate('/LoginJustGoogle');
      });
  };

  render() {
    return (
      <div className="Home">
        <h1 className="H1Basic">Профил</h1>

        <div className="arrowBackButtonDiv_CG">
          <DesignerButton
            class="arrowBackButton"
            onClick={this.handleGoBackRoom}></DesignerButton>
        </div>

        <div className={"profilePictureOuterHolder" + (this.state.userStatus === "Premium" ? " premium" : "")}>
          <div
            htmlFor={'contained-button-file-'}
            className="profilePictureHolder"
            style={{
              backgroundImage: `url(${this.state.profilePicture})`,
            }}>
            <input
              className="handleImageInput"
              accept="image/*"
              id={'contained-button-file-'}
              multiple
              type="file"
              onChange={(e) => this.handleUploadClick(e)}
            />
            <div
              htmlFor={'contained-button-file-'}
              className={"penButton" + (this.state.userStatus === "Premium" ? " premium" : "")}
              style={{
                zIndex: 1,
                width: '16px',
                height: '16px',
                position: 'relative',
                top: '45px',
                left: ' 35px',
              }}></div>
          </div>
        </div>

        <label className="selectLabel">Име/Псевдоним</label>
        <DesignerTextField
          style={{ width: '90%', marginBottom: '20px' }}
          value={this.state.userNickname}
          onChange={(event) => {
            this.setState({ userNickname: event.target.value });
          }}></DesignerTextField>

        <label className="selectLabel">Имейл адрес</label>
        <DesignerTextField
          disabled={true}
          style={{ width: '90%', marginBottom: '50px' }}
          value={this.state.userEmail}
          onChange={(event) => {
            this.setState({ userEmail: event.target.value });
          }}></DesignerTextField>

        {/* {this.state.userStatus === 'Basic' && ( */}
        <DesignerButton
          id="premiumStatus-purchase"
          class="filledButton"
          style={{
            fontSize: '14px',
            height: '60px',
            width: '90%',
            marginBottom: '10px',
          }}
          onClick={this.handlePurchase}
          disabled={this.state.userStatus === 'Premium'}
          buttonText="Купи Премиум"></DesignerButton>
        {/* )} */}

        <DesignerButton
          class="hollowButton"
          style={{
            fontSize: '14px',
            height: '60px',
            width: '90%',
            marginBottom: '80px',
          }}
          onClick={this.SaveChanges}
          buttonText="Запази Промени"></DesignerButton>

        <DesignerButton
          class="hollowButton"
          style={{
            fontSize: '14px',
            height: '60px',
            width: '90%',
          }}
          onClick={this.deleteAccount}
          buttonText="Изтрии Акаунт"></DesignerButton>
      </div>
    );
  }
}

export default withCookies(Profile);
